export default __webpack_public_path__ + "static/media/YAS0070.34I-27546_-16535_0.670e4141.jpg";